// extracted by mini-css-extract-plugin
export default {"LeadName":"LeadName-module-b6498cb97ec5aae6b903"};